import './filters_component.scss'
import { Controller } from 'stimulus'
import { desktop } from 'relation-map/utils'

export default class extends Controller {
  static classes = ['open', 'hidden']
  static targets = ['panel', 'control', 'toggle', 'hub', 'hubType']

  connect = (): void => {
    this.resize()
    this.observe(this.menuSectionController.element, this.resize)
    setTimeout(this.resize, 250)
  }

  resize = (): void => {
    if (this.closed) {
      this.panelTarget.style.width = `${this.controlWidth}px`
    } else {
      if (desktop()) {
        this.panelTarget.style.width = 'initial'
      } else {
        this.panelTarget.style.width = 'auto'
      }
    }
    this.toggleControls()
  }

  observe = (element: HTMLElement[], callback: Function): void => {
    return new ResizeObserver(() => {
      callback()
    }).observe(element)
  }

  toggle = (): void => {
    if (this.open) {
      this.panelTarget.classList.remove(this.openClass)
      this.menuController.close()
    } else {
      this.panelTarget.classList.add(this.openClass)
      this.menuController.open()
    }
    this.resize()
  }

  toggleControls = (): void => {
    if (this.overflowingContent) {
      this.toggleTarget.classList.remove(this.hiddenClass)
    } else {
      this.toggleTarget.classList.add(this.hiddenClass)
    }

    if (this.open) {
      this.toggleTarget.classList.remove(this.hiddenClass)
    }
  }

  reset = (): void => {
    this.hubTarget.value = ''
    this.hubTypeTarget.value = ''
  }

  get open (): boolean {
    return this.panelTarget.classList.contains(this.openClass)
  }

  get closed (): boolean {
    return !this.open
  }

  get controlWidth (): number {
    return this.menuSectionController.element.offsetWidth - this.controlTarget.offsetWidth - 9
  }

  get menuController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.menu'), 'menu')
  }

  get menuSectionController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.menu_section'), 'menu-section')
  }

  get overflowingContent (): boolean {
    return this.overflowingSpace > 0
  }

  get availableSpace (): number {
    return this.panelTarget.offsetWidth - this.childrenWidth
  }

  get overflowingSpace (): number {
    return this.childrenWidth - this.panelTarget.offsetWidth
  }

  get childrenWidth (): number {
    const children = this.panelTarget.children
    let totalWidth = 0

    for (let i = 0; i < children.length; i++) {
      totalWidth += parseInt(children[i].offsetWidth, 10)
    }

    return totalWidth
  }
}
